import { http } from '@/http'
import qs       from 'query-string'

export const validator = {
  isEmail (inputText) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    if (inputText.match(mailformat)) {
      return true
    }
    else {
      return false
    }
  },
  verifyEmail (emailText) {
    let data = qs.stringify({ token: emailText })

    return true

    http.post(
      '/User/VerifyEmail',
      data,
      {
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        }
      }
    )
        .then(response => {

        })
        .catch(e => {
          console.error(e)
        })
  }
}
